import { renderCell } from "@/utils/tableConfigs/GlobalFunctions";
import RiskStatusIcon from "@/views/Risk/shared/RiskStatusIcon";
import type { BreachTableRow } from "./utils";

type SeverityCellProps = {
  value: BreachTableRow[string];
};

const getSeverityParts = (value: SeverityCellProps["value"]) => {
  if (typeof value !== "string") {
    return {
      label: renderCell(value),
      tone: "default" as const,
    };
  }

  const [rawLabel, rawTone] = value.split(",");
  const label = rawLabel?.trim() || value;
  const normalizedTone = rawTone?.trim().toLowerCase();

  if (normalizedTone === "red") {
    return { label, tone: "red" as const };
  }
  if (normalizedTone === "yellow") {
    return { label, tone: "yellow" as const };
  }
  if (normalizedTone === "green") {
    return { label, tone: "green" as const };
  }

  return {
    label,
    tone: "default" as const,
  };
};

export default function SeverityCell({ value }: SeverityCellProps) {
  const { label, tone } = getSeverityParts(value);

  return (
    <div className="flex items-center gap-2 text-[#2B4752]">
      <RiskStatusIcon tone={tone} />
      <span>{label}</span>
    </div>
  );
}
